import { space, layout } from "styled-system";
import styled from "styled-components";
import { presetImages } from "./preset-images";
import { jsx as _jsx } from "react/jsx-runtime";
export const Content = styled.div.withConfig({
  displayName: "backdrop__Content",
  componentId: "sc-1l7kwam-0"
})(["width:inherit;height:inherit;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
export const Wrapper = styled.div.withConfig({
  displayName: "backdrop__Wrapper",
  componentId: "sc-1l7kwam-1"
})(["width:100%;height:100%;display:table;overflow:auto;padding:", "px;background-color:", ";background-image:", ";background-attachment:fixed;background-size:cover;", " ", " &::before{display:table-cell;height:inherit;content:\"\";}"], p => p.theme.space.lg, p => p.theme.colors.primary[7], p => presetImages[p.preset ?? "prism"], space, layout);
export function Backdrop(_ref) {
  let {
    preset = "prism",
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Wrapper, {
    preset: preset,
    ...rest,
    children: /*#__PURE__*/_jsx(Content, {
      children: children
    })
  });
}
export default Backdrop;